<template>
  <div class="store-box">
    <app-header title="服务选择" @goback="goBack">
      <div slot="tips" @click="confirm">
        <div class="header-right">确定</div>
      </div>
    </app-header>
    <div class="search-box">
      <cube-input class="cube-input" placeholder="请输入门店名称" v-model="searchText"></cube-input>
    </div>
    <pull-to :is-top-bounce="false" :is-bottom-bounce="isLoadAll" :bottom-load-method="loadmore">
      <ul class="store-list">
        <li v-for="(item, index) in storeList" :key="index" @click="check(item, index)">
          <checkbox disabled v-model="checkedIds" class="list-checkbox" :value="productType === 1 ? item.depId : item.deviceId" ref="checkbox"></checkbox>
          <div>{{ productType === 1 ? item.deptName : item.deviceName }}</div>
        </li>
      </ul>
    </pull-to>
  </div>
</template>

<script>
import { commonMixin } from 'common/js/mixin';
import apis from 'api/index';
import PullTo from 'vue-pull-to';
import { Style, Input } from 'cube-ui';
import { Checkbox } from 'vue-checkbox-radio';
import { inArray } from 'common/js/utils';
import { mapState } from 'vuex';
import _ from 'lodash';

export default {
  mixins: [commonMixin],
  components: {
    PullTo,
    cubeInput: Input,
    Checkbox,
  },
  data() {
    return {
      storeList: [],
      storeTotal: 0,
      pageNumber: 1,
      pageSize: 20,
      checkedIds: [],
      searchText: '',
      selectList: [], // 存checkIDs里对应的数据
    }
  },
  created() {
    if( this.productType === 1) {
      this.fetchStoreList();
    } else if(this.productType === 2) {
      this.fetchDeviceList();
    }
    
  },
  computed: {
    isLoadAll() {
      return Boolean(this.storeTotal > this.pageNumber * this.pageSize);
    },
    productType() {
      return this.currentOrder.productType;
    },
    ...mapState(['currentOrder', 'currentStore'])
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    // 点击行选中
    check(item, index) {
      this.$refs.checkbox[index].toggle(item.depId);
    },
    gogogo(item, index) {
      this.$refs.checkbox[index].toggle(item.depId);
    },
    loadmore(loaded) {
      if(this.storeTotal <= this.pageNumber * this.pageSize) {
        return false;
      }
      this.pageNumber +=1;
      this.fetchStoreList().then(res => {
        loaded('done');
      });
    },
    // 获取产品列表
    async fetchStoreList(type = 'normal') {
      try {
        let params = {
          no: this.pageNumber,
          limit: this.pageSize,
          moduleId: this.$route.params.id,
          open: false,
          deptName: this.searchText
        }
        const res = await apis.getStore(params);
        if(type === 'normal') {
          this.storeList = this.storeList.concat(res.records);
        } else {
          this.storeList = res.records;
        }
        this.storeTotal = res.total;
      } catch(err) {
        console.error(err);
      }
    },
    // 获取设备列表
    async fetchDeviceList(type = 'normal') {
      try {
        let params = {
          no: this.pageNumber,
          limit: this.pageSize,
          moduleId: this.$route.params.id,
          open: false,
          deviceType: 2,
          productId: this.currentOrder.productId
        };
        const res = await apis.getDevice(params);
        if(type === 'normal') {
          this.storeList = this.storeList.concat(res.records);
        } else {
          this.storeList = res.records;
        }
        this.storeTotal = res.total;
      } catch(err) {
        console.error(err);
      }
    },
    async confirm() {
      // type为1，正常入网操作， 为2时只能选择一家门店多选报错，进行转换操作
      if(this.checkedIds.length === 0) {
        this.showToast('请选择门店');
        return false;
      } else if (this.checkedIds.length > 1 && this.$route.query.type === 2) { // 转入只能单个操作
        this.showToast('转入的门店只能选择一家');
        return false;
      }
      try {
        if(this.$route.query.type === 1) { // 正常入网
          // 验证用户选择的门店数是否大于订单开通数
          if(this.checkedIds.length > this.currentOrder.surplusNum) {
            this.showToast('订单开通数量不满足当前使用数量！');
            return false;
          }
          let params = {};
          params.openRecords = this.selectList;
          params.ids = [this.currentOrder.id];
          const res = await apis.useProduct(JSON.stringify(params));
          this.showDialog('入网成功','alert' , () => {
            this.$router.go(-1);
          });
        } else { // 转换门店
          let params = {
            ids: [this.currentStore.id],
            status: 3,
          }
          if(this.productType === 1) {
            params.depId = this.selectList[0].depId;
            params.deptName = this.selectList[0].deptName;
            params.deptAddress = this.selectList[0].address;
          } else if(this.productType === 2){
            params.deviceId = this.selectList[0].deviceId;
            params.deviceName = this.selectList[0].deviceName;
            params.mac = this.selectList[0].mac;
          }
          const res = await apis.updateRenewType(params);
          this.showDialog('转换成功','alert' , () => {
            this.$router.go(-1);
          });
        }
      } catch(err) {
        console.error(err);
      }
    }
  },
  watch: {
    searchText(nVal) {
      this.pageNumber = 1;
      this.fetchStoreList('reset');
    },
    checkedIds(nVal, oVal) {
      // 由于这个组件没有什么change事件，而且后台那边要我把除了ID的另外两个字段也返回，我storeList里面并没有所有的数据
      // 只能在checkedIds变化的时候，将他选中的list存到一个新数组里面
      let selectId = nVal[nVal.length - 1];
      let cancelId = _.difference(oVal, nVal)[0];
      // 如果最后一个id不存在在前面的数组里，表示是新增操作
      if(nVal.length === 0 || (nVal.length !== 0 && inArray(selectId, oVal))) { // 此时是取消勾选操作
        // 找到取消的那个玩意的index，然后删掉这个垃圾
        let index = this.selectList.findIndex(item => (this.productType === 1 ? item.depId : item.deviceId) === cancelId);
        this.selectList.splice(index, 1);
      } else { // 此时是勾选操作
        // 新增刚刚勾选的
        let newSelect = this.storeList.filter(item => (this.productType === 1 ? item.depId : item.deviceId) === selectId)[0];
        this.selectList.push(newSelect);
      }
    }
  }
}
</script>

<style src="./netin.scss" lang="scss" scoped></style>